import { getEnv } from '../../../utils/runtimeConfig';
import type { PolicyConfig } from './types';

// To update the Privacy Policy (for non-technical editors):
//   1. Open frontend/public/legal/privacy.md on GitHub.
//   2. Click the pencil icon, edit the markdown (GitHub shows a live preview),
//      commit on a branch, open a PR.
//   3. [Optional] If the title or dates change, update the `header` block below in the same PR.
//   4. Ask a developer to bump the POLICY_VERSION env var on the backend (K8s secret)
//      so existing users are prompted to re-accept.
//
// To move the source elsewhere (e.g. cloud storage):
//   Set REACT_APP_PRIVACY_POLICY_URL at runtime (via env-config.js / K8s secret).
//   Nothing in this file needs to change.

export const PRIVACY_CONFIG: PolicyConfig = {
  tabLabel: 'Privacy Policy',

  header: {
    kicker: 'LEGAL',
    title: 'Reality Coach Privacy Policy',
    // No dates shown in header — effective date is inside the body.
  },

  contentUrl: getEnv('REACT_APP_PRIVACY_POLICY_URL') ?? '/legal/privacy.md',
};
